import { UserRole } from '@mairistem/finances-utils';
import TypePeriode from '../../constants/simulation/typePeriode';

export interface ServiceRestriction {
	identifiantSvutCpta: number;
	identifiantsServicesUtilisateur: number[];
}

// Permet de savoir si on desactive les champs par manque d'habilitation
const isInputDisabled = (
	transfertCpta: boolean,
	typePeriode: TypePeriode,
	userRole: UserRole,
	gestionnaireCanWhenDemande = false,
	serviceRestriction?: ServiceRestriction,
	blockNonProprietaire = false,
) => {
	// Si on est transfere en compta, plus de modification de montant
	if (transfertCpta) return true;

	// Si la gestion de service est active, un Gestionnaire/Normal ne peut agir que sur
	// les montants dont il est l'auteur et dont le service fait partie de ses propres
	// services. Un Charge de pilotage/Admin n'est pas soumis a ces restrictions.
	if (userRole < UserRole.CHARGE_PILOTAGE) {
		if (blockNonProprietaire) return true;

		if (
			serviceRestriction &&
			!serviceRestriction.identifiantsServicesUtilisateur.includes(
				serviceRestriction.identifiantSvutCpta,
			)
		) {
			return true;
		}
	}

	switch (typePeriode) {
		case TypePeriode.DEMANDE:
			// Admin/ChargePilotage/(Gestionnaire si autorise)
			return (
				userRole <
				(gestionnaireCanWhenDemande
					? UserRole.GESTIONNAIRE
					: UserRole.CHARGE_PILOTAGE)
			);
		case TypePeriode.CA_CFU:
		case TypePeriode.PROPOSE:
		case TypePeriode.VOTE:
			// Admin/ChargePilotage
			return userRole < UserRole.CHARGE_PILOTAGE;
		default:
			return true;
	}
};

export default isInputDisabled;
